import React from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import { BSBtnDropdown } from "traec-react/utils/bootstrap/";
import Traec from "traec";
import { isSuperuser } from "traec-react/utils";
import { counter } from "./company";
import { confirmDelete } from "traec-react/utils/sweetalert";

export default class CompanyItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  deleteCompany(e) {
    e.preventDefault();
    let { company } = this.props;
    let companyId = company ? company.get("uid") : null;
    if (!companyId) {
      return null;
    }
    let companyName = company.get("name");
    confirmDelete({
      text: `This will delete the company: ${companyName}.  Are you sure you would like to proceed?`,
      onConfirm: () => {
        new Traec.Fetch("company", "delete", { companyId }).dispatch();
      },
    });
  }

  render_menu() {
    if (!isSuperuser(this.props.user)) {
      return null;
    }
    return <BSBtnDropdown links={[{ name: "Delete", onClick: this.deleteCompany.bind(this) }]} />;
  }

  render_children() {
    let { company, allCompanies, dispatch, indentLevel, index, user } = this.props;
    if (!company) {
      return null;
    }
    let childids = company.get("childids");
    if (!childids) {
      return null;
    }
    let subCompanies = childids.map((childid, i) => {
      let child = allCompanies.get(childid);
      if (!child) {
        return null;
      }
      return (
        <CompanyItem
          key={i}
          index={index}
          indentLevel={indentLevel + 1}
          company={child}
          allCompanies={allCompanies}
          dispatch={dispatch}
          user={user}
        />
      );
    });
    return <React.Fragment>{subCompanies}</React.Fragment>;
  }

  render() {
    let { company, indentLevel, index: i } = this.props;
    let rowNum = counter.row++;

    let companyId = company.get("uid");
    companyId = companyId ? companyId.substring(0, 8) : null;
    if (!company.get("name")) {
      return null;
    }

    return (
      <React.Fragment>
        <div className="row" key={i} style={{ backgroundColor: (rowNum + 1) % 2 ? "#ddd" : "" }}>
          <div className="col-sm-12">
            <span style={{ marginLeft: `${indentLevel * 1}em` }}>
              <Link to={`/company/${companyId}`}>{company.get("name")}</Link>
            </span>
            {this.render_menu()}
          </div>
        </div>
        {this.render_children()}
      </React.Fragment>
    );
  }
}
